import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLetterTop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 280,
	height: 119,
	viewBox: "0 0 280 119",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M280 118.613H0L129.718 4.64605C135.484 -0.420379 144.113 -0.426611 149.887 4.63149L280 118.613Z",
		fill: "#A7C4FC"
	})
});
export default SvgLetterTop;
